import React from 'react';
var Rayo = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "21", height: "21", viewBox: "0 0 21 21" },
        React.createElement("g", { id: "estado", transform: "translate(-708 -35)" },
            React.createElement("path", { id: "Vector", d: "M1.62,0,.111,2A.8.8,0,0,0,.8,3.194H2.634a.8.8,0,0,1,.695,1.2l-1.709,2", transform: "translate(716.782 42.306)", fill: "none", stroke: "var(--blanco)", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", strokeDasharray: "0 0" }))));
};
Rayo.defaultProps = {
    className: '',
};
export default Rayo;
